<!-- 主营业务 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="service-main">
            <div class="service-item">
                <div class="serves-name">标准业务：</div>
                <div class="serves-content-default" :key="'standardDefault_' + index"
                    v-for="(item, index) in standardDefaultList">
                    <el-checkbox border v-model="item.IsSelect" :checked="item.IsSelect">{{ item.Name }}</el-checkbox>
                </div>
                <div class="serves-content" :key="'standardCustom_' + index" v-for="(item, index) in standardCustomList">
                    <el-checkbox border v-model="item.IsSelect" :checked="item.IsSelect">{{ item.Name }}</el-checkbox>
                    <i class="el-icon-circle-close serves-del" @click="delItem(0, index)"></i>
                </div>
                <el-input class="input-new-tag serves-name" v-if="standardVisible" v-model="standardValue"
                    ref="saveTagInput" @keyup.enter.native="handleStandardConfirm" @blur="handleStandardConfirm"></el-input>
                <el-button v-else class="button-new-tag serves-name" @click="showStandard">＋添加标准业务</el-button>
            </div>
            <div class="service-item">
                <div class="serves-name">特色业务：</div>
                <div class="serves-content-default" :key="'specialDefault_' + index"
                    v-for="(item, index) in specialDefaultList">
                    <el-checkbox border v-model="item.IsSelect" :checked="item.IsSelect">{{ item.Name }}</el-checkbox>
                </div>
                <div class="serves-content" :key="'specialCustom_' + index" v-for="(item, index) in specialCustomList">
                    <el-checkbox border v-model="item.IsSelect" :checked="item.IsSelect">{{ item.Name }}</el-checkbox>
                    <i class="el-icon-circle-close serves-del" @click="delItem(1, index)"></i>
                </div>
                <el-input class="input-new-tag serves-name" v-if="specialVisible" v-model="specialValue"
                    ref="saveSpecialInput" @keyup.enter.native="handleSpecialConfirm"
                    @blur="handleSpecialConfirm"></el-input>
                <el-button v-else class="button-new-tag serves-name" @click="showSpecial">＋添加特色业务</el-button>
            </div>
            <div style="text-align: right">
                <el-button class="btn-primary" @click="submitForm"
                    v-if="permission.submit">{{ permission.submit }}</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
export default {
    mixins: [mixin],
    name: "",
    components: { breadcrumb },
    data() {
        let userMsg = this.$util.getLocalStorage("userMsg");
        return {
            userMsg: userMsg,
            // 标准业务
            standardVisible: false,
            standardValue: "",
            // 特色业务
            specialVisible: false,
            specialValue: "",
            submitData: {
                userId: userMsg.EmployeeId,
                standardServiceList: [],
                specialServiceList: [],
            },
            standardDefaultList: {},
            standardCustomList: {},
            specialDefaultList: {},
            specialCustomList: {},
            permission: {},
        };
    },
    mounted() {
        this.permission = this.$util.getPermission("service");
        this.getData();
    },
    methods: {
        getData() {
            let that = this;
            this.$util
                .axiosGet({
                    url: "/api/EntpInfoManagement/GetEntpService"
                })
                .then((res) => {
                    let data = res.data;

                    that.standardDefaultList = data.StandardService.DefaultList;
                    that.standardCustomList = data.StandardService.CustomList;
                    that.specialDefaultList = data.SpecialService.DefaultList;
                    that.specialCustomList = data.SpecialService.CustomList;

                    that.submitData.specialServiceList = [
                        ...data.SpecialService.DefaultList,
                        ...data.SpecialService.CustomList,
                    ];
                    that.submitData.standardServiceList = [
                        ...data.StandardService.DefaultList,
                        ...data.StandardService.CustomList,
                    ];
                });
        },
        // 提交数据
        submitForm() {
            this.submitData.specialServiceList = [
                ...this.specialDefaultList,
                ...this.specialCustomList,
            ];
            this.submitData.standardServiceList = [
                ...this.standardDefaultList,
                ...this.standardCustomList,
            ];
            this.$util
                .axiosPost({
                    url: "/api/EntpInfoManagement/SaveEnterpriseService",
                    data: this.submitData,
                })
                .then((res) => {
                    this.$util.successMsg("保存成功");
                });
        },
        // 标准服务
        showStandard() {
            this.standardVisible = true;
            this.$nextTick((_) => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleStandardConfirm() {
            let target = this.submitData.standardServiceList;
            for (let i = 0; i < target.length; i++) {
                if (target[i].Name == this.standardValue) {
                    this.$util.warningMsg("该服务已存在");
                    return;
                }
            }
            let inputValue = this.standardValue;
            if (inputValue) {
                this.submitData.standardServiceList.push({
                    Name: inputValue,
                    IsSelect: true,
                });
                this.standardCustomList.push({
                    Name: inputValue,
                    IsSelect: true,
                });
            }
            this.standardVisible = false;
            this.standardValue = "";
        },
        // 特色服务
        showSpecial() {
            this.specialVisible = true;
            this.$nextTick((_) => {
                this.$refs.saveSpecialInput.$refs.input.focus();
            });
        },
        handleSpecialConfirm() {
            let target = this.submitData.specialServiceList;
            for (let i = 0; i < target.length; i++) {
                if (target[i].Name == this.specialValue) {
                    this.$util.warningMsg("该服务已存在");
                    return;
                }
            }
            let inputValue = this.specialValue;
            if (inputValue) {
                this.submitData.specialServiceList.push({
                    Name: inputValue,
                    IsSelect: true,
                });
                this.specialCustomList.push({
                    Name: inputValue,
                    IsSelect: true,
                });
            }
            this.specialVisible = false;
            this.specialValue = "";
        },
        delItem(type, index) {
            if (type == 0) {
                this.standardCustomList.splice(index, 1);
            } else {
                this.specialCustomList.splice(index, 1);
            }
        },
    },
};
</script>
<style lang="less" scoped>
.serves-name {
    margin-bottom: 20px;
}

.service-main {
    max-width: 800px;
    margin: 0 auto;
    padding-top: 50px;
}

.service-item {
    font-size: @font-md;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding-bottom: 50px;
}

.input-new-tag {
    width: 90px;
    margin-left: 20px;
}

.button-new-tag {
    margin-left: 20px;
}

.serves-content {
    display: flex;
    margin-bottom: 20px;
    margin-left: 10px;
}

.serves-content-default {
    display: flex;
    margin-bottom: 20px;
    margin-right: 17px;
    margin-left: 10px;
}

.serves-del {
    background-color: #ffffff;
    height: 17px;
    width: 17px;
    position: relative;
    right: 14px;
    bottom: 4px;
    color: #c2ccd0;
}
</style>
